
import { Vue, Component } from "vue-property-decorator";
import { Html5QrcodeScanner, Html5QrcodeScanType, Html5QrcodeSupportedFormats } from "html5-qrcode";

@Component({})
export default class Html5Qrcode extends Vue {

  private html5QrcodeScanner: any = null;

  private mounted() {
    const config = {
      fps: 10,
      qrbox: 250,
      supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA],
      formatsToSupport: [ Html5QrcodeSupportedFormats.QR_CODE ],
    };
    this.html5QrcodeScanner = new Html5QrcodeScanner(
      "qr-code-full-region",
      config,
      false,
    );
    this.html5QrcodeScanner.render(this.onDecode, undefined);
  }

  private onDecode(decodedText: string): void {
    if (decodedText) {
      // this.$emit("decode", decodedText);
    }
  }
}
